import airfryerUnit from "../../images/unit/airfryer.png";
import mixerUnit from "../../images/unit/mixerUnit.png";
import projectorUnit from "../../images/unit/projectorUnit.png";
import drillUnit from "../../images/unit/drillUnit.png";
import chairsUnit from "../../images/unit/chairsUnit.png";
import chairs from "../../images/unit/chairs.png";
import drill from "../../images/unit/TLV_DRILL.png";
import white_oculus from "../../images/unit/white_oculus.png";
import vrUnit from "../../images/unit/vrUnit.png";
import projector from "../../images/unit/Projector.png";
import mixer from "../../images/unit/Mixer.png";
import printer from "../../images/unit/printer.png";
import consolePlay from "../../images/unit/ps-5.png";
import soutcase from "../../images/unit/soutcase.png";
import dyson from "../../images/unit/dyson.png";
import shopUnit from "../../images/unit/shopUnit.png";
import robot_mop from "../../images/unit/robot_mop.png";
import mattressUnit from "../../images/unit/matress.png";
import mattress from "../../images/unit/mattress.png";
import robotMopUnit from "../../images/unit/robot-mop.png";

import karcherVacuumUnit from "../../images/unit/karcherVacuumUnit.png";
import toolBox from "../../images/unit/toolBox.png";
import toolboxUnit from "../../images/unit/toolboxUnit.png";

export const baseType = {
  basic100: "basic100",
  basic200: "basic200",
  basic400: "basic400",
  basic800: "basic800",
  extra: "extra",
};

const position = {
  top: 1,
  middle: 2,
  bottom: 3,
  shop: 4,
};
export const population = {
  students: "students",
  elders: "elders",
  youngProfessionals: "youngProfessionals",
  families: "families",
  postgraduate: "postgraduate",
  undergraduate: "undergraduate",
  communityCenter: "communityCenter",
  neighborhood: "neighborhood",
  municipality: "municipality",
  sharedOffice: "sharedOffice",
  corporate: "corporate",
  startup: "startup",
  officeBuilding: "officeBuilding",
  hotel: "hotel",
  hostel: "hostel",
  extendedStays: "extendedStays",
  other: "other",
};

const location = {
  europe: "eu",
  usa: "us",
  israel: "il",
  uk: "uk",
};

const colorsCategory = {
  fitness: {
    color: "#d4dfe8",
    gradientColor: "#B9C9D6",
    category: "Rental item | Fitness",
    type: "rentals",
  },
  clean: {
    color: "#e0a79b",
    gradientColor: "#c78779",
    category: "Rental item | Clean",
    type: "rentals",
  },
  play: {
    color: "#618A83",
    gradientColor: "#73c4bb",
    category: "Rental item | Play",
    type: "rentals",
  },
  print: {
    color: "#6F859E",
    gradientColor: "#8da8d0",
    category: "Print",
    type: "rentals",
  },
  host: {
    color: "#BC8080",
    gradientColor: "#ef9691",
    category: "Rental item | Host",
    type: "rentals",
  },
  cook: {
    color: "#D58160",
    gradientColor: "#e69679",
    category: "Rental item | Cook",
    type: "rentals",
  },
  diy: {
    color: "#965353",
    gradientColor: "#bf6465",
    category: "Rental item | DIY",
    type: "rentals",
  },
  outdoor: {
    color: "#3E5B55",
    gradientColor: "#006458",
    category: "Rental item | OutDoor",
    type: "rentals",
  },
  shop: {
    color: "#f2be7a",
    gradientColor: "#ffc982",
    category: "Buy item | Shop",
    type: "shop",
  },
  shopHandle: {
    color: "#f2be7a",
    gradientColor: "#ffc982",
    category: "Buy item | Shop",
    type: "shop",
  },
  ride: {
    color: "#a1a0a0",
    gradientColor: "#dcdcdc",
    category: "Ride",
    type: "ride",
  },
  system: {
    color: "translate",
    gradientColor: "translate",
    category: "System",
    type: "system",
  },
};

const unitBoxSizes = {
  small: { size: 78, cellSize: 1 },
  medium: { size: 174, cellSize: 2 },
  mediumL: { size: 270, cellSize: 3 },
  large: { size: 366, cellSize: 4 },
  largeL: { size: 462, cellSize: 5 },
  xl: { size: 558, cellSize: 6 },
  monitor: { size: 366, cellSize: 4 },
};

export const createItem = (item, key) => {
  const {
    amount,
    electric_standart,
    retail_price,
    tulu_price,
    countinunit,
    security_door,
    Europe,
    uk,
    USA,
    israel,
    basetype,
    category,
    cellsize,
    description,
    counts_100_200,
    counts_200_400,
    counts_400_800,
    counts_800,
    id,
    image,
    link,
    model,
    population,
    position: itemPosition,
    title,
    unitImage,
    us_currency,
    eu_currency,
    uk_currency,
    il_currency,
    table_items,
  } = item;

  return {
    key: key.toLowerCase(),
    id,
    countInUnit: countinunit,
    position:
      itemPosition === "shop"
        ? position.shop
        : itemPosition === "top"
        ? position.top
        : itemPosition === "middle"
        ? position.middle
        : position.bottom,
    cellSize: parseInt(cellsize),
    ...getSize(cellsize),
    ...colorsCategory[category],
    image: image?.url,
    unitImage: unitImage?.url,
    title,
    model,
    electric_standart,
    table_items,
    description,
    security_door,
    amount,
    us_currency,
    eu_currency,
    uk_currency,
    il_currency,
    retail_price,
    tulu_price,
    showDoor:
      category !== "shop" && category !== "print" && category !== "system",
    population: !population?.[0]?.populations
      ? null
      : population.map((e) => e.populations),
    link: link?.url,
    location: getItemLocation({ Europe, USA, israel, uk }),
    baseType: {
      residential: basetype?.[0].residential || 0,
      studentHousing: basetype?.[0].studentHousing || 0,
      office: basetype?.[0].office || 0,
      community: basetype?.[0].community || 0,
      hospitality: basetype?.[0].hospitality || 0,
    },
    counts: {
      "100-200": {
        ...counts_100_200[0],
        studentHousing: counts_100_200[0].studenthousing,
      },
      "200-400": {
        ...counts_200_400[0],
        studentHousing: counts_200_400[0].studenthousing,
      },
      "400-800": {
        ...counts_400_800[0],
        studentHousing: counts_400_800[0].studenthousing,
      },
      "800+": {
        ...counts_800[0],
        studentHousing: counts_800[0].studenthousing,
      },
    },
  };
};

const getSize = (cellsize) => {
  return Object.values(unitBoxSizes).find((e) => e.cellSize + "" === cellsize);
};

const getItemLocation = ({ Europe, USA, israel, uk }) => {
  const locationRes = [];
  if (Europe !== false) {
    locationRes.push(location.europe);
  }
  if (USA !== false) {
    locationRes.push(location.usa);
  }
  if (israel !== false) {
    locationRes.push(location.israel);
  }
  if (uk !== false) {
    locationRes.push(location.uk);
  }

  return locationRes.length === 0 ? null : locationRes;
};

export const itemsPopUp = {
  monitor: {
    type: "monitor",
    color: "#13647b",
    ...unitBoxSizes.monitor,
    showDoor: false,
    position: -1,
    gradientColor: "#0a323e",
    frameColor: "#FFFFFF",
    baseType: {
      residential: baseType.basic100,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
  },
  robotMop: {
    id: "Robot Mop",
    countInUnit: 1,
    position: position.top,
    ...unitBoxSizes.small,
    ...colorsCategory.clean,
    title: "Robot Mop",
    model: "irobot | Braava jet m6",
    image: robot_mop,
    unitImage: robotMopUnit,
    link: "https://tulu-assets.s3.eu-west-1.amazonaws.com/how_to_use/iRobotBraavaJetM6",
    baseType: {
      residential: baseType.basic100,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": {
        residential: 1,
        studentHousing: 1,
        office: 1,
        community: 1,
        hospitality: 0,
        retail: 1,
        other: 2,
      },
      "200-400": {
        residential: 1,
        studentHousing: 1,
        office: 1,
        community: 1,
        hospitality: 0,
        retail: 1,
        other: 2,
      },
      "400-800": {
        residential: 1,
        studentHousing: 1,
        office: 1,
        community: 1,
        hospitality: 0,
        retail: 1,
        other: 2,
      },
      "800+": {
        residential: 1,
        studentHousing: 1,
        office: 1,
        community: 1,
        hospitality: 0,
        retail: 1,
        other: 2,
      },
    },
  },
  airfryer: {
    id: "Airfryer",
    position: position.middle,
    countInUnit: 1,
    ...unitBoxSizes.medium,
    ...colorsCategory.cook,
    title: "Airfryer",
    model: "Philips | TurboStar Technology",
    image: airfryerUnit,
    unitImage: airfryerUnit,
    link: "https://tulu-assets.s3.amazonaws.com/items/AirFryer",
    baseType: {
      residential: baseType.basic400,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 1,
      "200-400": 1,
      "400-800": 1,
      "800+": 1,
    },
  },
  mixer: {
    id: "Mixer",
    countInUnit: 1,
    position: position.middle,
    ...unitBoxSizes.medium,
    ...colorsCategory.cook,
    title: "Mixer",
    model: "KitchenAid | KSM75SL Classic",
    image: mixer,
    unitImage: mixerUnit,
    link: "https://tulu-assets.s3.amazonaws.com/items/Unagi%20Scooters%20playbook",
    baseType: {
      residential: baseType.basic400,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 1,
      "200-400": 1,
      "400-800": 1,
      "800+": 1,
    },
  },
  shop: {
    id: "Shop",
    countInUnit: 1,
    type: "shop",
    position: position.bottom,
    ...unitBoxSizes.large,
    color: "#a1a0a0",
    image: shopUnit,
    unitImage: shopUnit,
    gradientColor: "#dcdcdc",
    ...colorsCategory.shop,
    title: "Shop",
    link: "https://tulu-assets.s3.amazonaws.com/items/Unagi%20Scooters%20playbook",
  },
  printer: {
    id: "Printer",
    countInUnit: 1,
    position: position.middle,
    ...unitBoxSizes.medium,
    ...colorsCategory.print,
    frameColor: "#b6af9c",
    showDoor: false,
    image: printer,
    unitImage: printer,
    title: "Printer",
    model: "HP | Color LaseJet Pro M254dw",
    link: "https://tulu-assets.s3.amazonaws.com/items/Unagi%20Scooters%20playbook",
  },
  consolePlay: {
    id: "Gaming Console",
    position: position.top,
    countInUnit: 1,
    ...unitBoxSizes.small,
    ...colorsCategory.play,
    image: consolePlay,
    unitImage: consolePlay,
    title: "Gaming Console",
    model: "Sony | PlayStation 5",
    link: "https://tulu-assets.s3.amazonaws.com/items/Unagi%20Scooters%20playbook",
    baseType: {
      residential: baseType.basic100,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 1,
      "200-400": 1,
      "400-800": 1,
      "800+": 2,
    },
  },
  homeTheaterProjector: {
    id: "Home Theater Projector",
    countInUnit: 1,
    position: position.middle,
    ...unitBoxSizes.small,
    ...colorsCategory.play,
    image: projector,
    unitImage: projectorUnit,
    title: "Home Theater Projector",
    model: "BenQ | TK800M 4K UHD",
    link: "https://tulu-assets.s3.amazonaws.com/items/Unagi%20Scooters%20playbook",
    baseType: {
      residential: baseType.basic200,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 1,
      "200-400": 1,
      "400-800": 1,
      "800+": 1,
    },
  },
  vr: {
    id: "VR Headset",
    countInUnit: 1,
    position: position.middle,
    ...unitBoxSizes.small,
    ...colorsCategory.play,
    image: white_oculus,
    unitImage: vrUnit,
    title: "VR Headset",
    model: "Oculus Quest | All-in-one",
    link: "https://tulu-assets.s3-eu-west-1.amazonaws.com/how to use/how_to_use_VR_Headset_Playbook.pdf",
    baseType: {
      residential: baseType.basic100,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 1,
      "200-400": 1,
      "400-800": 2,
      "800+": 2,
    },
  },
  drillDriver: {
    id: "Drill Driver",
    position: position.middle,
    countInUnit: 1,
    ...unitBoxSizes.small,
    ...colorsCategory.diy,
    image: drill,
    unitImage: drillUnit,
    title: "Drill Driver",
    model: "Makita | HP331DWYE",
    link: "https://tulu-assets.s3.amazonaws.com/items/Unagi%20Scooters%20playbook",
    baseType: {
      residential: baseType.basic100,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 1,
      "200-400": 1,
      "400-800": 1,
      "800+": 1,
    },
  },
  toolbox: {
    id: "Tool Box",
    position: position.middle,
    countInUnit: 1,
    ...unitBoxSizes.small,
    ...colorsCategory.diy,
    image: toolBox,
    unitImage: toolboxUnit,
    title: "Tool Box",
    model: "********",
    link: "https://tulu-assets.s3.amazonaws.com/items/Unagi%20Scooters%20playbook",
    baseType: {
      residential: baseType.basic100,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 1,
      "200-400": 1,
      "400-800": 1,
      "800+": 1,
    },
  },
  foldingChairs: {
    id: "Folding Chairs",
    countInUnit: 4,
    position: position.bottom,
    ...unitBoxSizes.large,
    ...colorsCategory.host,
    image: chairs,
    unitImage: chairsUnit,
    title: "Folding Chairs",
    model: "IKEA | Nisse",
    link: "https://tulu-assets.s3.amazonaws.com/items/Unagi%20Scooters%20playbook",
    baseType: {
      residential: baseType.basic100,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 1,
      "200-400": 1,
      "400-800": 1,
      "800+": 1,
    },
  },
  suitcase: {
    id: "suitcase",
    countInUnit: 1,
    position: position.middle,
    ...unitBoxSizes.large,
    ...colorsCategory.clean,
    image: soutcase,
    unitImage: soutcase,
    location: [location.europe],
    title: "VR Headset",
    model: "Oculus Quest | All in one",
    link: "https://tulu-assets.s3.amazonaws.com/items/Unagi%20Scooters%20playbook",
    baseType: {
      residential: baseType.basic100,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 0,
      "200-400": 0,
      "400-800": 0,
      "800+": 1,
    },
  },
  dyson: {
    id: "Vacuum cleaner",
    countInUnit: 2,
    position: position.bottom,
    ...unitBoxSizes.xl,
    ...colorsCategory.clean,
    image:
      "https://static.wixstatic.com/media/97c9a0_a9962a905ecd4895914981da28bb8b1c~mv2.png",
    unitImage: dyson,
    title: "Vacuum cleaner",
    model: "Dyson | V11 Torque Drive",
    link: "https://tulu-assets.s3.eu-west-1.amazonaws.com/null/Dyson%20V11%20Torque%20PDF",
    location: [location.usa, location.israel],
    baseType: {
      residential: baseType.basic100,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 1,
      "200-400": 1,
      "400-800": 2,
      "800+": 2,
    },
  },
  karcherVacuum: {
    id: "Kärcher vacuum",
    countInUnit: 2,
    position: position.bottom,
    ...unitBoxSizes.large,
    ...colorsCategory.clean,
    image: karcherVacuumUnit,
    unitImage: karcherVacuumUnit,
    title: "Kärcher vacuum",
    model: "Dyson | V11 Torque Drive",
    link: "https://tulu-assets.s3.eu-west-1.amazonaws.com/null/Dyson%20V11%20Torque%20PDF",
    location: [location.europe],
    baseType: {
      residential: baseType.basic100,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 1,
      "200-400": 1,
      "400-800": 2,
      "800+": 2,
    },
  },
  mattress: {
    id: "Air Mattress",
    countInUnit: 1,
    position: position.bottom,
    ...unitBoxSizes.medium,
    ...colorsCategory.host,
    image: mattress,
    unitImage: mattressUnit,
    title: "Air Mattress",
    model: "*******",
    link: "https://tulu-assets.s3.amazonaws.com/items/Unagi%20Scooters%20playbook",
    baseType: {
      residential: baseType.basic100,
      studentHousing: baseType.basic100,
      office: baseType.basic100,
      community: baseType.basic100,
      hospitality: baseType.basic100,
      retail: baseType.basic100,
      other: baseType.basic100,
    },
    counts: {
      "100-200": 1,
      "200-400": 1,
      "400-800": 1,
      "800+": 1,
    },
  },
};

export const getItems = (items, _location, types, property, sizeUnit) => {
  const byTypes = getByTypes(Object.values(items), types);
  const arrLocation = getLocation(byTypes, _location);
  return getCounts(arrLocation, sizeUnit, property);
};

export const getLocation = (arr, _location) => {
  return arr.filter((e) => !e.location || e.location.includes(_location));
};

export const getByTypes = (arr, types) => {
  return arr.filter((e) => types.includes(e?.type));
};

export const getCounts = (arr, sizeUnit, property) => {
  const res = [];
  arr.forEach((item) => {
    if (!item.counts) {
      res.push(item);
    } else if (
      typeof item.counts[sizeUnit] === "number" &&
      item.counts[sizeUnit] > 0
    ) {
      for (let i = 0; i < item.counts[sizeUnit]; i++) {
        res.push(item);
      }
    } else if (
      typeof item.counts[sizeUnit]?.[property] === "number" &&
      item.counts[sizeUnit]?.[property] > 0
    ) {
      for (let i = 0; i < item.counts[sizeUnit]?.[property]; i++) {
        res.push(item);
      }
    }
  });

  return res;
};
